import type { IOverviewJointBillService } from "@services/overview/types";
import { api } from "@/api";
import type { IElectricityLeadsData, ISubmitElectricityLeads } from "./types";

export const getElectricityLeads = () =>
  api.get<IElectricityLeadsData>(`/electricity-leads`).then((r) => r.data);

export const submitElectricityLeadsRequest = ({
  data,
  jointBillServiceId,
}: {
  data: ISubmitElectricityLeads;
  jointBillServiceId: IOverviewJointBillService["jointBillServiceId"];
}) =>
  api.post<void>("/electricity-leads", data, {
    headers: {
      jointBillServiceId,
    },
  });
